import angular from 'angular';

import component from './errorList.component';
import constants from '../../constants';
import errorMessageModule from '../errorMessage';

let module = angular.module('recaps.components.errorList', [
  constants,
  errorMessageModule.name,
]);

module.component('errorList', component);

export default module;
